import { render, staticRenderFns } from "./detailNoContentModal.vue?vue&type=template&id=30549796&"
import script from "./detailNoContentModal.vue?vue&type=script&lang=js&"
export * from "./detailNoContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports